import { SVGIconType } from '../../models/enums'
import SVGIcon from '../SVGIcon/SVGIcon'
import { sidebarBulletItem } from './SidebarBulletItem.css'

type SidebarBulletItemProps = {
  bullet: string
  onClick?: () => void
}

const SidebarBulletItem = (props: SidebarBulletItemProps) => {
  const { bullet, onClick } = props

  const handlerClickItem = () => {
    onClick && onClick()
  }

  return (
    <li
      onClick={handlerClickItem}
      className={onClick ? sidebarBulletItem : ''}
      data-testid="bullet-item"
    >
      <SVGIcon width={25} height={20} icon={SVGIconType.CheckMark} />
      <p>{bullet}</p>
    </li>
  )
}

export default SidebarBulletItem
